// product-family-cards

function swapCardsForProductStyleOptions(option, value, swiper, sticky = false) {
  return
  if (option !== 'hem') return

  const productInfo = document.querySelector('product-info')
  if (!productInfo) return

  const currentFabric = productInfo.dataset.styleFabric

  const productFamilyCards = sticky
    ? document.querySelector('.product-family-cards--sticky')
    : document.querySelector('.product-family-cards')
  if (!productFamilyCards) return

  const cards = productFamilyCards.querySelectorAll('.product-family-card')
  cards.forEach((card) => {
    const isSameFabric = card.dataset.styleFabric?.toLowerCase() === currentFabric?.toLowerCase()
    const matchesNewHem = card.dataset.styleHem?.toLowerCase() === value?.toLowerCase()
    if (
      card.dataset.productFamily !== 'short-sleeve-curved-hem-classic-crew' &&
      card.dataset.productFamily !== 'short-sleeve-classic-crew'
    ) {
      card.style.display = 'none'
    }
    card.classList.remove('active')
    if (matchesNewHem || typeof card.dataset.styleHem === 'undefined') {
      card.style.display = 'block'
      if (matchesNewHem && isSameFabric) {
        card.classList.add('active')
      }
    }
  })
  swiper.update()
}

function initializeProductFamilyCirclesSwiper() {
  const productFamilyCards = document.querySelector('.product-family-cards')
  if (!productFamilyCards) return

  const swiperElement = productFamilyCards.closest('.js-swiper')
  if (!swiperElement) return

  if (typeof Swiper === 'undefined') return console.error('Swiper is not loaded')

  const swiperContainer = document.querySelector('.product-family-cards__swiper-container')
  const swiperPrevButton = swiperContainer?.querySelector('.swiper-button-prev')
  const swiperNextButton = swiperContainer?.querySelector('.swiper-button-next')

  try {
    const swiper = new Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 5,
      slidesOffsetAfter: 10,
      slidesOffsetBefore: 10,
      breakpoints: {
        768: {
          spaceBetween: 10,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          centerInsufficientSlides: true,
        },
      },
      navigation: {
        nextEl: swiperNextButton,
        prevEl: swiperPrevButton,
      },
      on: {
        beforeInit: () => {
          const container = document.querySelector('.product-family-cards-container')
          if (!container) return
          container.style.overflow = 'unset'
          swiperContainer.style.width = 'auto'
        },
        afterInit: () => {
          setTimeout(() => {
            swiperPrevButton.classList.remove('loading')
            swiperNextButton.classList.remove('loading')
          }, 100)
        },
      },
    })
    window.enablePdpDesktopSwiperMousewheel(swiper)
    productFamilyCards.classList.remove('swiper-loading')

    document.addEventListener('product-style-updated', (e) =>
      swapCardsForProductStyleOptions(e.detail.styleOption, e.detail.styleValue, swiper),
    )

    return swiper
  } catch (error) {
    console.error('Failed to initialize Swiper:', error)
  }
}

function initializeProductFamilyCardsSwiper() {
  const allWrappers = document.querySelectorAll(
    '.product-family-cards:not(.product-family-cards--sticky)',
  )
  if (!allWrappers.length) return

  if (typeof Swiper === 'undefined') return console.error('Swiper is not loaded')

  allWrappers.forEach((productFamilyCards) => {
    const swiperElement = productFamilyCards.closest('.js-swiper')
    if (!swiperElement) return

    // find original top level container on PDP (if we're on a PDP)
    const onPDP = !!productFamilyCards.closest(
      '.product-family-cards-container.pfc-product.pfc-original',
    )
    const numVisibleCards = productFamilyCards.querySelectorAll(
      '.product-family-card:not([style*="display: none"])',
    ).length

    const swiperContainer = productFamilyCards.closest('.product-family-cards__swiper-container')
    const swiperPrevButton = swiperContainer?.querySelector('.swiper-button-prev')
    const swiperNextButton = swiperContainer?.querySelector('.swiper-button-next')

    const isComparison = !!productFamilyCards.closest('.pfc-comparison')

    try {
      const swiper = new Swiper(swiperElement, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        slidesOffsetAfter: 10,
        slidesOffsetBefore: 10,
        centerInsufficientSlides: isComparison,
        breakpoints: {
          769: {
            spaceBetween: 10,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
          },
        },
        navigation: {
          nextEl: swiperNextButton,
          prevEl: swiperPrevButton,
        },
        on: {
          afterInit: () => {
            setTimeout(() => {
              swiperPrevButton?.classList.remove('loading')
              swiperNextButton?.classList.remove('loading')
            }, 100)
          },
        },
      })
      window.enablePdpDesktopSwiperMousewheel(swiper)
      productFamilyCards.classList.remove('swiper-loading')

      document.addEventListener('product-style-updated', (e) =>
        swapCardsForProductStyleOptions(e.detail.styleOption, e.detail.styleValue, swiper),
      )
    } catch (error) {
      console.error('Failed to initialize Swiper:', error)
    }
  })
}

function initializeProductFamilyCardsStickySwiper() {
  const productFamilyCards = document.querySelector('.product-family-cards--sticky')
  if (!productFamilyCards) return

  const swiperElement = productFamilyCards.closest('.js-swiper--sticky')
  if (!swiperElement) return

  if (typeof Swiper === 'undefined') return console.error('Swiper is not loaded')

  try {
    const swiper = new Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 5,
      slidesOffsetAfter: 10,
      slidesOffsetBefore: 10,
      centerInsufficientSlides: true,
      breakpoints: {
        767: {
          spaceBetween: 10,
        },
      },
    })
    window.enablePdpDesktopSwiperMousewheel(swiper)
    productFamilyCards.classList.remove('swiper-loading')

    document.addEventListener('product-style-updated', (e) =>
      swapCardsForProductStyleOptions(e.detail.styleOption, e.detail.styleValue, swiper, true),
    )

    return swiper
  } catch (error) {
    console.error('Failed to initialize Swiper:', error)
  }
}

function equalizeComparisonElements(selector) {
  const layout = document.querySelector('.pfc-comparison-layout')
  if (!layout) return

  const elements = layout.querySelectorAll(selector)
  if (!elements.length) return

  elements.forEach((el) => (el.style.minHeight = ''))

  let maxHeight = 0
  elements.forEach((el) => {
    if (el.offsetHeight > maxHeight) maxHeight = el.offsetHeight
  })

  elements.forEach((el) => (el.style.minHeight = `${maxHeight}px`))
}

function equalizeComparisonDescriptions() {
  equalizeComparisonElements('.product-family-card-button > p')
  equalizeComparisonElements('.pfc-comparison-grid__cell--fabric-colors')
}

function alignComparisonLabels() {
  const labelsCol = document.querySelector('.pfc-comparison-labels-column')
  if (!labelsCol) return

  const firstCardBtn = document.querySelector(
    '.pfc-comparison-layout .product-family-card .product-family-card-button',
  )
  if (!firstCardBtn) return

  const grid = labelsCol.querySelector('.pfc-comparison-grid__column')
  if (!grid) return

  // match the card's button height + the card grid's own 12px margin-top
  grid.style.marginTop = `${firstCardBtn.offsetHeight + 12}px`
}

function initializeSwipers() {
  const isClearancePage = window?.location?.pathname?.includes('top-deals-clearance')
  if (isClearancePage) {
    initializeProductFamilyCirclesSwiper()
  } else {
    initializeProductFamilyCardsSwiper()
    initializeProductFamilyCardsStickySwiper()
  }
}

function alignComparison() {
  equalizeComparisonDescriptions()
  alignComparisonLabels()
}

document.addEventListener('DOMContentLoaded', () => {
  initializeSwipers()
  alignComparison()
})
window.addEventListener('resize', alignComparison)

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.product-family-cards')) {
    initializeSwipers()
    alignComparison()
  } else {
    console.error('ERR: productFamilyCardsElement not found')
  }
})

document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll('.product-family-card-filter-on-click')
  if (!cards) return

  const filterKey = 'filter.p.m.pdp_app.info'

  cards.forEach((card) => {
    const filterValue = `gid://shopify/Metaobject/${card.dataset.productFamily}`
    card.addEventListener('click', () => {
      triggerCollectionFilters(card.dataset.collectionHandle, { [filterKey]: filterValue }, card)
    })
  })
})

async function triggerCollectionFilters(handle, params) {
  const url = new URL(`/collections/${handle}`, location.origin)
  Object.entries(params).forEach(([k, v]) =>
    Array.isArray(v) ? v.forEach((x) => url.searchParams.append(k, x)) : url.searchParams.set(k, v),
  )
  const sectionId = document.getElementById('product-grid').dataset.id
  url.searchParams.set('section_id', sectionId)

  const oldSection = document.getElementById(`shopify-section-${sectionId}`)

  oldSection.style.opacity = 0

  const html = await fetch(url).then((response) => response.text())
  const doc = new DOMParser().parseFromString(html, 'text/html')
  const newSection = doc.getElementById(`shopify-section-${sectionId}`)
  newSection.style.opacity = 0
  oldSection.replaceWith(newSection)

  setTimeout(() => {
    newSection.style.transition = 'opacity 0.5s'
    newSection.style.opacity = 1

    window.scrollToSection(newSection, 10)
  }, 500)

  history.pushState(
    {},
    '',
    `${window.Shopify.routes.root}${url.pathname.slice(1)}` +
      '?' +
      url.searchParams
        .toString()
        .replace(/section_id=[^&]*&?/g, '')
        .replace(/&$/, ''),
  )
}

// Redirect international visitors away from the US-only clearance page
function redirectInternationalClearance() {
  const nonUS = (window.Shopify?.country || 'US').toUpperCase() !== 'US'
  if (!nonUS) return

  const match = location.pathname.match(/^(.*)\/collections\/top-deals-clearance\/?$/)
  if (!match) return

  const localePrefix = match[1] // may be '' when on root market
  const newPath = `${localePrefix}/collections/top-deals-clearance-international`.replace(
    /\/\//,
    '/',
  )

  location.replace(newPath + location.search + location.hash)
}

document.addEventListener('DOMContentLoaded', redirectInternationalClearance)

async function loadCollectionGrid({
  collectionHandle,
  hostSectionSelector = '#main-collection-product-grid',
  updateURL = false,
  urlParams = {},
  callforward = () => {},
  callback = () => {},
}) {
  if (!collectionHandle) return

  callforward()

  const hostSection = document.querySelector(hostSectionSelector)
  const sectionWrapper = hostSection?.closest('.shopify-section')
  const sectionId = sectionWrapper?.id?.replace('shopify-section-', '')
  if (!hostSection || !sectionId) return

  const currentCollectionHandle = hostSection.dataset.collectionHandle
  if (currentCollectionHandle === collectionHandle) {
    callback(hostSection)
    return
  }

  try {
    const url = new URL(
      `${window.Shopify?.routes?.root || '/'}collections/${collectionHandle}`,
      location.origin,
    )
    url.searchParams.set('section_id', sectionId)

    // Fade out current section for smoother UX
    hostSection.style.opacity = 0.5

    const html = await fetch(url).then((r) => r.text())
    const doc = new DOMParser().parseFromString(html, 'text/html')
    const newSection = doc.getElementById(`shopify-section-${sectionId}`)
    if (!newSection) return

    newSection.style.opacity = 0.5

    sectionWrapper.replaceWith(newSection)

    // Fade in the new section after a short tick
    requestAnimationFrame(() => {
      newSection.style.transition = 'opacity 0.5s'
      newSection.style.opacity = 1
    })

    if (updateURL) window.updateURLwithParams(url, urlParams)

    document.dispatchEvent(new Event('collection-grid-loaded'))

    const selectedTitleWrapper = document.querySelector('.pfc-selected-title__wrapper')
    const targetSection = selectedTitleWrapper || newSection

    callback(targetSection)
  } catch (err) {
    console.error('loadCollectionGrid failed:', err)
  }
}
window.loadCollectionGrid = loadCollectionGrid

function updateActiveCard(card) {
  const item = card.closest('li') || card
  const list = item.parentElement
  if (!list) return

  list
    .querySelectorAll('.product-family-card.active')
    .forEach((el) => el.classList.remove('active'))
  card.classList.add('active')

  const selectedTitleWrapper = document.querySelector('.pfc-selected-title__wrapper')
  if (!selectedTitleWrapper) return

  const newTitle = card.querySelector('h3')?.textContent
  if (!newTitle) return

  const titleElement = selectedTitleWrapper.querySelector('.pfc-selected-title__title')
  titleElement.style.opacity = 0
  setTimeout(() => {
    titleElement.textContent = newTitle
    titleElement.style.opacity = 1
  }, 125)
}
window.updateActiveCard = updateActiveCard

function createVdayBadgeIfNeeded(prodInfo) {
  const isVdayLp = window.location.pathname.includes('/pages/lp/valentine')
  const existingBadge = document.querySelector('.vday-badge')
  const galleryMain = document.querySelector('.liquid-pdp__gallery-main')
  // console.log('vday badge check:', { isVdayLp, existingBadge: !!existingBadge, galleryMain: !!galleryMain })
  if (isVdayLp && !existingBadge && galleryMain) {
    const department = prodInfo?.dataset?.department || ''
    const isWomens = department.toLowerCase() === 'womens'
    const badgeText = isWomens ? '💝 Great Gift for Her' : '🎁 Great Gift for Him'
    const badge = document.createElement('div')
    badge.className = 'vday-badge'
    badge.innerHTML = `<span class="vday-badge__label">${badgeText}</span>`
    galleryMain.appendChild(badge)
    // console.log('vday badge created:', badgeText)
  }
}

async function updatePDP(productHandle, activeProductHandle = productHandle) {
  // console.log('updatePDP', productHandle)
  const productInfo =
    document.querySelector('.shopify-section.liquid-pdp product-info') ||
    document.querySelector('menu-with-pdp product-info')
  if (!productInfo) return
  const updateUrl = !productInfo.closest('menu-with-pdp') && window.isMultiFamilyLp !== true

  document.addEventListener(
    'product-info-updated',
    () => {
      const prodInfo = document.querySelector('.shopify-section.liquid-pdp product-info')
      if (prodInfo) {
        //window.scrollToSection(prodInfo, 78)
        const childCategoryName = prodInfo.dataset.childCategoryName
        if (childCategoryName) {
          const breadcrumbsWrapper = document.querySelector('.liquid-pdp__breadcrumbs')
          const childCategoryNameElement = breadcrumbsWrapper.querySelector('.child-category-name')
          if (childCategoryNameElement) {
            childCategoryNameElement.textContent = childCategoryName
              .replace(/Boys'|Boys|Girls'|Girls|Womens|Mens|Tall|Long Sleeve|Short Sleeve|/g, '')
              .trim()
          }
        }
        // Recreate vday badge if on vday LP (small delay to let DOM settle)
        setTimeout(() => createVdayBadgeIfNeeded(prodInfo), 100)
      }
    },
    { once: true },
  )

  // Fallback check after 3 seconds in case something else removed the badge
  setTimeout(() => {
    const prodInfo = document.querySelector('.shopify-section.liquid-pdp product-info')
    if (prodInfo) createVdayBadgeIfNeeded(prodInfo)
  }, 3000)

  requestAnimationFrame(() => {
    productInfo.style.transition = 'opacity 0.5s'
    productInfo.style.opacity = 0.5
    productInfo.style.pointerEvents = 'none'
  })

  productInfo.changeFullSection(productHandle, updateUrl)

  document.querySelectorAll('.product-family-cards').forEach((wrapper) => {
    wrapper.querySelectorAll('.product-family-card').forEach((child) => {
      child.classList.remove('active')
      if (child.dataset.productHandle === activeProductHandle) child.classList.add('active')
    })
  })
}
window.updatePDP = updatePDP
